import { PropsWithChildren, useState } from 'react'

import { ChevronDownIcon } from '@radix-ui/react-icons'
import * as Popover from '@radix-ui/react-popover'
import { styled } from 'style'

import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

const AbsoluteAnchor = styled(Popover.Anchor, {
  position: 'absolute',
  right: 0,
  left: 0,
  bottom: 5,
  width: '$full',
})

type NavbarDropdownProps = {
  name: string
}

export const NavbarDropdown = (
  props: PropsWithChildren<NavbarDropdownProps>,
) => {
  const { name, children } = props
  const [open, setOpen] = useState(false)

  return (
    <Popover.Root open={open}>
      <Box
        as="li"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <Popover.Trigger asChild>
          <Box
            as="button"
            flex
            items="center"
            justify="between"
            onClick={() => setOpen(s => !s)}
            css={{
              spaceX: 1,
              color: '$text1',
              '@sm': { px: '$2' },
              '&:focus': { outline: 'none' },
            }}
          >
            <AbsoluteAnchor /> {/* to center dropdown content */}
            <Text size="sm">{name}</Text>
            <IconStyled
              as={ChevronDownIcon}
              size="sm"
              css={{
                '[data-state=open] &': { transform: 'rotate(-180deg)' },
                '@media (prefers-reduced-motion: no-preference)': {
                  transition: 'transform 0.2s ease',
                },
              }}
            />
          </Box>
        </Popover.Trigger>
        <Popover.Content asChild>{children}</Popover.Content>
      </Box>
    </Popover.Root>
  )
}
